module.exports = __webpack_public_path__ + "static/img/header_768.3c44695.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/header_768.png
// module id = kHmN
// module chunks = 0